(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iurop-stores"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-stores-directory-trigger]');
    if (!trigger) return;
    requestAnimationFrame(() => {
      if (!trigger.parentElement.open) return;
      trigger.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    if (!event.target.closest('.iurop-stores')) return;
    let details = event.target.closest('details');
    while (details) {
      details.open = true;
      details = details.parentElement.closest('details');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
